import { render } from "./SiteDetails.vue?vue&type=template&id=3b831d2c&scoped=true"
import script from "./SiteDetails.vue?vue&type=script&lang=js"
export * from "./SiteDetails.vue?vue&type=script&lang=js"

import "./SiteDetails.vue?vue&type=style&index=0&id=3b831d2c&scoped=true&lang=css"

import exportComponent from "D:\\projects\\paintcare\\pcsitelocator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b831d2c"]])

export default __exports__